import { Component } from '@angular/core';
import { MessagesGeneral, MessagesStatus, MessagesTitles } from 'app/models/messages';
import { LoginService } from 'app/services/login/login.service';
import { ListadoRepComercialComponent } from './listado-rep-comercial/listado-rep-comercial.component';
import { ReporteFacturaNegociadaComponent } from './factura-negociada/factura-negociada.component';

@Component({
  selector: 'app-rep-comercial',
  templateUrl: './rep-comercial.component.html',
  styleUrls: ['./rep-comercial.component.scss'],
  providers:[ListadoRepComercialComponent,MessagesTitles, MessagesGeneral, MessagesStatus,ReporteFacturaNegociadaComponent]
})
export class RepComercialComponent{

  constructor(private loginService: LoginService,
    private listado:ListadoRepComercialComponent,
    private listadoReporte:ReporteFacturaNegociadaComponent
    ) { }

  clickGuard() {
    this.loginService.clickGuard = true;
  }
  ExportTOExcel() {
   this.listadoReporte.ExportTOExcel()
  }
}
